/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBrowser: {
  name: 'browser';
  data: string;
} = {
  name: 'browser',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm14 6V5H5v4h14ZM5 11h14v8H5v-8Zm7-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
